
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as agentsU5Rt9IeZsLMeta } from "/var/www/lottobox-agent/pages/agent/agents.vue?macro=true";
import { default as dashboardCCOWUy0cpBMeta } from "/var/www/lottobox-agent/pages/agent/dashboard.vue?macro=true";
import { default as email_45setupt37fJQFQ7VMeta } from "/var/www/lottobox-agent/pages/agent/email-setup.vue?macro=true";
import { default as loginT98JxagLT5Meta } from "/var/www/lottobox-agent/pages/agent/login.vue?macro=true";
import { default as playersJNap9fgtLRMeta } from "/var/www/lottobox-agent/pages/agent/players.vue?macro=true";
import { default as group_45salesWW6Bgsp0bRMeta } from "/var/www/lottobox-agent/pages/agent/report/group-sales.vue?macro=true";
import { default as groupstrike5IZieJORRrMeta } from "/var/www/lottobox-agent/pages/agent/report/groupstrike.vue?macro=true";
import { default as wallet_45indexYY71EJbqgxMeta } from "/var/www/lottobox-agent/pages/agent/report/wallet-index.vue?macro=true";
import { default as weekly_profit6bHijgVcO5Meta } from "/var/www/lottobox-agent/pages/agent/report/weekly_profit.vue?macro=true";
import { default as reset_45passwordAxaI0WX7nwMeta } from "/var/www/lottobox-agent/pages/agent/reset-password.vue?macro=true";
import { default as set_45pincgoATQM0EqMeta } from "/var/www/lottobox-agent/pages/agent/set-pin.vue?macro=true";
import { default as transferQA8nSe5bZKMeta } from "/var/www/lottobox-agent/pages/agent/transfer.vue?macro=true";
import { default as indexchzNJ5lFNKMeta } from "/var/www/lottobox-agent/pages/index.vue?macro=true";
export default [
  {
    name: "agent-agents",
    path: "/agent/agents",
    meta: agentsU5Rt9IeZsLMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/agents.vue")
  },
  {
    name: "agent-dashboard",
    path: "/agent/dashboard",
    meta: dashboardCCOWUy0cpBMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/dashboard.vue")
  },
  {
    name: "agent-email-setup",
    path: "/agent/email-setup",
    meta: email_45setupt37fJQFQ7VMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/email-setup.vue")
  },
  {
    name: "agent-login",
    path: "/agent/login",
    meta: loginT98JxagLT5Meta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/login.vue")
  },
  {
    name: "agent-players",
    path: "/agent/players",
    meta: playersJNap9fgtLRMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/players.vue")
  },
  {
    name: "agent-report-group-sales",
    path: "/agent/report/group-sales",
    meta: group_45salesWW6Bgsp0bRMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/report/group-sales.vue")
  },
  {
    name: "agent-report-groupstrike",
    path: "/agent/report/groupstrike",
    meta: groupstrike5IZieJORRrMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/report/groupstrike.vue")
  },
  {
    name: "agent-report-wallet-index",
    path: "/agent/report/wallet-index",
    meta: wallet_45indexYY71EJbqgxMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/report/wallet-index.vue")
  },
  {
    name: "agent-report-weekly_profit",
    path: "/agent/report/weekly_profit",
    meta: weekly_profit6bHijgVcO5Meta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/report/weekly_profit.vue")
  },
  {
    name: "agent-reset-password",
    path: "/agent/reset-password",
    meta: reset_45passwordAxaI0WX7nwMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/reset-password.vue")
  },
  {
    name: "agent-set-pin",
    path: "/agent/set-pin",
    meta: set_45pincgoATQM0EqMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/set-pin.vue")
  },
  {
    name: "agent-transfer",
    path: "/agent/transfer",
    meta: transferQA8nSe5bZKMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/agent/transfer.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexchzNJ5lFNKMeta || {},
    component: () => import("/var/www/lottobox-agent/pages/index.vue")
  }
]